import { inject, Injectable, Injector } from '@angular/core';
import { MessageService } from 'primeng/api';
import { TranslocoService } from '@ngneat/transloco';
import { RxToast } from '../enum/rx-toast.enum';

@Injectable({ providedIn: 'root' })
export class RxToastService {
  #messageService: MessageService = inject(MessageService);
  #transloco: TranslocoService;

  constructor(private injector: Injector) {
    try {
      this.#transloco = this.injector.get(TranslocoService);
    } catch {
      this.#transloco = undefined;
    }
  }

  show(type: RxToast, message: string, options: { life?: number; closable?: boolean; translate?: boolean } = {}): void {
    const { life = 4000, closable = false, translate = true } = options;

    this.#messageService.add({
      severity: type,
      detail: translate && this.#transloco ? this.#transloco.translate(message) : message,
      life,
      closable,
    });
  }
}
